import axios from "axios";


export default {


    setUser({commit}) {
        axios.get(process.env.VUE_APP_BACKEND_URL + '/userinfo/current')
            .then(resp => {
                commit('setUser', resp.data);
            })
            .catch(err => {
                console.error('getCurrentUser error', err);
            })
    },


    clearUser({commit}) {
        commit('clearUser');
    }
}
